export const GETPRODUCTMGTLIST = "GETPRODUCTMGTLIST";
export const GETDETAIL = "GETDETAIL";
export const UPDATEPRODUCTDETAIL="UPDATEPRODUCTDETAIL";

export const PRODUCTMGTERROR="PRODUCTMGTERROR";
export const PRODUCTMGTERRORNULL="PRODUCTMGTERRORNULL";